import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private api: ApiService) { }
  getResult(): Observable<any> {
    return this.api.get(`Account/Get`);
  }

  // do Login
  userLogin(login): Observable<any> {
    return this.api.post('Account/Login', login);
  }

  changepassword(login): Observable<any> {
    return this.api.post('Account/ChangePassword', login);
  }

  getChain(type, code): Observable<any> {
    return this.api.get('/Chain/GetChain?type=' + type + '&code=' + code);
  }
  GenerateQRCode(code): Observable<any> {
    return this.api.get('Admin/GenerateQRCode?content=' + code);
  }
  getPromoterJoining(code): Observable<any> {
    return this.api.get(`Account/GetJoiningDetails?code=${code}`);
  }

  getProfilePic(pcode): Observable<any> {
    return this.api.get(`UserDetails/GetProfilePic?pcode=${pcode}`);
  }

  UploadPromoterProfilePic(obj): Observable<any> {
    return this.api.post('UserDetails/UploadPromoterProfilePic', obj);
  }

  UploadDocs(obj): Observable<any> {
    return this.api.post('UserDetails/UploadDocs', obj);
  }


  GetCustomerById(id): Observable<any> {
    return this.api.get('UserDetails/GetCustomerById?id=' + id);
  }

  GetAppCustomers(code): Observable<any> {
    return this.api.get('UserDetails/GetAppCustomers?pcode=' + code);
  }

  GetAppPromoters(code): Observable<any> {
    return this.api.get('UserDetails/GetAppPromoters?pcode=' + code);
  }

  AddPromoters(user): Observable<any> {
    return this.api.post('UserDetails/AddPromoters', user);
  }
  GetPromoterById(id): Observable<any> {
    return this.api.get('UserDetails/GetPromoterById?id=' + id);
  }
  GetPromoterDocs(id): Observable<any> {
    return this.api.get('UserDetails/GetPromoterDocs?id=' + id);
  }

  GetCustomerByCode(code): Observable<any> {
    return this.api.get('UserDetails/GetCustomerByCode?code=' + code);
  }

  AddCustomer(user): Observable<any> {
    return this.api.post('UserDetails/AddCustomer', user);
  }

  GetCustomerDocs(id): Observable<any> {
    return this.api.get('UserDetails/GetCustomerDocs?id=' + id);
  }

  UploadCustomerDocs(obj): Observable<any> {
    return this.api.post('UserDetails/UploadCustomerDocs', obj);
  }
  GetUserDetailsByCode(code): Observable<any> {
    return this.api.get('Account/GetUserDetailsByCode?code=' + code);
  }
  getdocsType(): Observable<any> {
    return this.api.get('Document/GetAllDocumentType');
  }

  DeleteBulkInstalment(id: number): Observable<any> {
    return this.api.delete('Instalment/DeleteBulkInstalment?id=' + id);
  }
  getBulkInstalment(code): Observable<any> {
    return this.api.get(`Instalment/GetBulkInstalment?code=${code}`);
  }

  saveBulkInstalment(obj): Observable<any> {
    return this.api.post('Instalment/SaveInstalmentRenewal', obj);
  }

  getInstalmentPaymentDetails(totalIns, code): Observable<any> {
    return this.api.get('Instalment/GetInstalmentPaymentDetails?totalIns=' + totalIns + '&code=' + code);
  }

  getInstalmentPayDetails(code): Observable<any> {
    return this.api.get('Instalment/GetInstalmentPayDetails?code=' + code);
  }

}
